import { useEffect, useState } from 'react';

import { useErrorDrawer } from '../providers/ErrorDrawerContext/error-drawer.context';

/**
 * Routes a failed list query (Customers / Invites / Requests, CSSD-1646)
 * through the global error drawer: a backend problem response opens the
 * drawer, anything else is reported back as `true` so the page shows
 * `ServerPagedTable`'s in-table error state instead. `showError` runs once
 * per error instance; a refetch that succeeds clears `error` and with it the
 * returned flag.
 *
 * @param error - The query's `error` (`null` while it has not failed).
 * @returns `true` when the error is the page's to show.
 */
export function useListError(error: unknown): boolean {
  const { showError } = useErrorDrawer();
  const [drawerError, setDrawerError] = useState<unknown>(null);

  useEffect(() => {
    if (error !== null && showError(error)) {
      setDrawerError(error);
    }
  }, [error, showError]);

  return error !== null && error !== drawerError;
}
